<template>
  <v-card>
    <v-toolbar flat tile dark color="primaryDark" height="40px">
      {{ $t("people.lblHistory") }}
      <v-spacer></v-spacer>
      <v-tooltip bottom v-if="$security.checkUserAccess('UpdatePeople')">
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            v-bind="attrs"
            v-on="on"
            outlined
            v-if="$security.checkUserAccess('UpdatePeople')"
            class="mr-2"
            color="primaryDark--text"
            small
            :disabled="!$security.checkUserAccess('UpdatePeople') || !isPhotoUploading"
            @click.stop="onAddHistory"
          >
            <v-icon left>mdi-plus</v-icon>{{ $t("people.AddHistory") }}
          </a-btn>
        </template>
        <span>{{ $t("people.AddHistory") }}</span>
      </v-tooltip>  
    </v-toolbar>
    <v-card-text>
      <v-timeline v-if="getHistory.length">
        <v-timeline-item
          v-for="(history, i) in getHistory"
          :key="i"
          color="pageHeader"
          small
        >
          <template v-slot:opposite>
            <span
              style="
                font-family: 'Noto Sans JP' !important;
                font-size: 18px !important;
              "
              v-if="history.yearMonth"
              :class="`title font-weight-bold pageHeader--text`"
              >{{ history.yearMonth }}</span
            >
          </template>
          <v-hover>
            <template v-slot:default="{ hover }">
              <v-card elevation="5" raised class="py-4" color="appBar">
                <div v-if="history.description">
                  <v-list-item
                    v-for="(text, index) in history.description"
                    :key="index"
                    small
                    dense
                    style="word-break: break-word"
                  >
                    <v-icon left>mdi-square-medium</v-icon>
                    {{ text }}
                  </v-list-item>
                </div>
                <v-fade-transition
                  v-if="$security.checkUserAccess('UpdatePeople')"
                >
                  <v-overlay
                    style="justify-content: right"
                    :z-index="1"
                    v-if="hover"
                    absolute
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          x-small
                          icon
                          width="24"
                          min-width="24"
                          class="mr-2"
                          @click="onHistoryEdit(history)"
                          :disabled='!isPhotoUploading'
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("people.tipUpdateHistory") }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          width="24"
                          min-width="24"
                          x-small
                          icon
                          @click="onHistoryDelete(history)"
                          :disabled='!isPhotoUploading'
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("people.tipDeleteHistory") }}</span>
                    </v-tooltip>
                  </v-overlay>
                </v-fade-transition>
              </v-card>
            </template>
          </v-hover>
        </v-timeline-item>
      </v-timeline>
      <span v-else>{{ $t("people.NoHistory") }}</span>
    </v-card-text>
    <add-history
      v-if="showHistoryAddDialog"
      v-model="showHistoryAddDialog"
      :history.sync="historyObject"
      @save="addHistory"
      :allHistoryData="getHistory"
      :isNewHistory="isNewHistory"
    ></add-history>
    <confirm-dialog ref="confirm" />
  </v-card>
</template>

<script>
import ConfirmDialog from "../ConfirmDialog.vue";
import AddHistory from "./AddHistory.vue";
import _ from "lodash";
export default {
  components: { AddHistory, ConfirmDialog },
  name: "PeopleHistory",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    isPhotoUploading: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    getHistory: {
      get() {
        return _.orderBy(this.value, ["yearMonth"], ["ASC"]);
      },
      set(values) {
        this.$emit("input", values);
      },
    },
  },
  watch: {
    showHistoryAddDialog(value) {
      if (!value) {
        this.reset();
      }
    },
  },
  data() {
    return {
      editHistoryLabel: null,
      overlay: false,
      showHistoryAddDialog: false,
      historyObject: {
        yearMonth: "",
        description: [],
      },
      isNewHistory: false
    };
  },
  methods: {
    onAddHistory,
    addHistory,
    onHistoryEdit,
    onHistoryDelete,
    ConfirmDelete,
    reset,
  },
};

async function ConfirmDelete() {
  if (
    await this.$refs.confirm.open(
      this.$t("agenda.hDeleteMessage"),
      this.$t("agenda.lblDeleteMessage")
    )
  ) {
    return true;
  }
}

function addHistory() {
  if (this.editHistoryLabel) {
    let result = this.value.find(
      (type) => type.yearMonth === this.editHistoryLabel
    );
    if (result) {
      result.yearMonth = this.historyObject.yearMonth;
      result.description = this.historyObject.description;
    }
  } else {
    const histList = [...this.getHistory];
    const existingYearMonth = histList.find(
      (f) => f.yearMonth === this.historyObject.yearMonth
    );
    if (existingYearMonth) {
      existingYearMonth.description = existingYearMonth.description.concat(
        this.historyObject.description
      );
    } else {
      histList.push(Object.assign({}, this.historyObject));
    }
    this.getHistory = [...histList];
  }
  this.showHistoryAddDialog = false;
}

function reset() {
  this.editHistoryLabel = null;
  this.historyObject = {
    yearMonth: "",
    description: [],
  };
}

function onAddHistory() {
  this.isNewHistory = true;
  this.showHistoryAddDialog = true;
}

function onHistoryEdit(item) {
  this.isNewHistory = false;
  this.editHistoryLabel = item.yearMonth;
  this.historyObject = Object.assign({}, item);
  this.showHistoryAddDialog = true;
}

async function onHistoryDelete(item) {
  const answer = await this.ConfirmDelete();
  if (answer) {
    const historyList = this.value.filter(
      (v) => v.yearMonth !== item.yearMonth
    );
    this.$emit("input", historyList);
  }
}
</script>

<style>
</style>